enum PageType {
    MAIN = 'Main',
    SEARCH = 'Search',
    HUBS = 'Hubs',
    BRANDS = 'Brands',
    CASTING = 'Casting',
    OTHER = 'Other',
}
type PageConfigType = {
    [pageType in PageType]: string | number;
};

const pageToIDMapping: PageConfigType = {
    [PageType.MAIN]: '111592',
    [PageType.SEARCH]: '199951',
    [PageType.HUBS]: '199951',
    [PageType.BRANDS]: '24451',
    [PageType.CASTING]: '24451',
    [PageType.OTHER]: '72001',
};

export { pageToIDMapping, PageType };
